import React, { useEffect, useState } from "react";
import { useUserServices } from "../context/DealerProfile";
import { toast } from "react-hot-toast";
import { Button, Modal } from "flowbite-react";
import CustomerTypeSelector from "../features/Address/CustomerTypeSelector";
import AddressForm from "../features/Address/AddressForm";
import ViewModeSelector from "../features/Address/ViewModeSelector";
import AddressList from "../features/Address/AddressList";
import { useLocation, useNavigate } from "react-router-dom";
import { mutate } from "swr";

const ShippingAddressesPage = () => {
  const { dealerDetail } = useUserServices();
  const { inHouseShipping, endCustomerShipping, accountName, dealerName } =
    dealerDetail || {};
  const [viewMode, setViewMode] = useState("table");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    customerType: "inHouse",
    Company_Name: "",
    CompName: "",
    Address_2: "",
    City: "",
    Postal_Code: "",
    Country: "",
    State: "",
    name: "",
    Email: "",
    Phone: "",
  });
  const [errors, setErrors] = useState({});
  const location = useLocation(); // Get location object
  const navigate = useNavigate(); // Get navigate function

  // console.log({accountName});

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const query = queryParams.get("query");
    const customerType = queryParams.get("customerType");

    if (query === "create") {
      setIsModalOpen(true);
      if (customerType) {
        setFormData((prev) => ({ ...prev, customerType }));
      }
    }
  }, [location.search, navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateForm = () => {
    const newErrors = {};

    // Validate Company Name
    if (!formData.Company_Name) {
      newErrors.Company_Name = "Address is required.";
    }
    if (!formData.CompName && formData.customerType === "endCustomer") {
      newErrors.CompName = "Company Name is required.";
    }
    if (!formData.Address_2 && formData.customerType !== "endCustomer") {
      newErrors.Address_2 = "Address is required.";
    }

    if (!formData.City && formData.customerType !== "endCustomer") {
      newErrors.City = "City is required.";
    }
    if (!formData.Country) {
      newErrors.Country = "Country is required.";
    }
    if (!formData.State && formData.customerType !== "endCustomer") {
      newErrors.State = "State is required.";
    }

    if (!formData.Postal_Code && formData.customerType !== "endCustomer") {
      newErrors.Postal_Code = "Postal_Code is required.";
    }

    // Validate fields for non-inHouse customer type
    if (formData.customerType !== "inHouse") {
      if (!formData.name) {
        newErrors.name = "Customer Name is required.";
      }

      // Validate Email
      if (!formData.Email) {
        newErrors.Email = "Email is required.";
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.Email)) {
        newErrors.Email = "Email is not valid.";
      }

      // Validate Phone Number
      // if (!formData.Phone) {
      //   newErrors.Phone = "Phone number is required.";
      // } else if (!/^\d{10}$/.test(formData.Phone)) {
      //   newErrors.Phone = "Phone number must be valid.";
      // }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      const requestBody = {
        Company_Name: formData.Company_Name,
        CompName: formData.CompName,
        Address_2: formData.Address_2,
        City: formData.City,
        Postal_Code: formData.Postal_Code,
        Country: formData.Country,
        State: formData.State,
        customerType: formData.customerType,
        Name: formData.Company_Name,
      };

      if (dealerName?.id) requestBody["Contacts"] = dealerName?.id;
      if (accountName?.id) requestBody["Channel_Partner"] = accountName?.id;
      if (formData.customerType !== "inHouse") {
        requestBody["Channel_Partner"] =
          dealerName?.id === null ? accountName?.id : "";
        requestBody.customerDetails = {
          name: formData.name,
          Country: formData.Country,
          Company_Name2: formData.CompName,
          Email: formData.Email,
          Phone: formData.Phone,
          Other_City: formData.City,
          Other_Zip: formData.Postal_Code,
          Other_Country: formData.Country,
          Other_State: formData.State,
          Other_Street: formData.Company_Name,
          Shipping_Street_2: formData.Address_2,
        };
      }

      const loadingToast = toast.loading("Creating shipping address...");

      console.log({ requestBody });
      console.log(formData.customerType);

      try {
        const response = await fetch(
          `/server/dealer_backend/create-address?addressType=Shipping&customerType=${formData.customerType}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
          }
        );

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        await response.json();
        // const result = await response.json();
        // console.log("Success:", result);

        toast.success("Shipping address added successfully!", {
          id: loadingToast,
        });

        mutate("/user"); // Refetch user details

        setIsModalOpen(false); // Close the modal after submission
        setFormData({
          customerType: "inHouse",
          Company_Name: "",
          Address_2: "",
          City: "",
          Postal_Code: "",
          Country: "",
          State: "",
          name: "",
          Email: "",
          Phone: "",
        });

        const historyUrl = new URLSearchParams(location.search).get("history");
        if (historyUrl) {
          navigate(historyUrl);
        }
      } catch (error) {
        console.error("Error submitting address:", error);
        toast.error("Failed to add shipping address. Please try again.", {
          id: loadingToast,
        });
      }
    } else {
      toast.error("Please fix the errors in the form.");
    }
  };

  useEffect(() => {
    if (!isModalOpen) setErrors({});
  }, [isModalOpen]);

  return (
    <div className="px-4 max-w-5xl mx-auto">
      <div className="flex justify-between my-4">
        <h2 className="text-2xl font-bold text-gray-700">Shipping Addresses</h2>

        <Button onClick={() => setIsModalOpen(true)}>
          Add Shipping Address
        </Button>
      </div>

      <div className="flex justify-between">
        {/* View Mode Selection */}
        <ViewModeSelector viewMode={viewMode} setViewMode={setViewMode} />

        {/* Customer Type Selection */}
        <CustomerTypeSelector formData={formData} setFormData={setFormData} />
      </div>

      <AddressList
        addresses={
          formData.customerType === "inHouse"
            ? inHouseShipping
            : endCustomerShipping
        }
        viewMode={viewMode}
        type="Shipping"
      />

      <Modal show={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <Modal.Header>Add Shipping Address</Modal.Header>
        <Modal.Body>
          <AddressForm
            formData={formData}
            errors={errors}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ShippingAddressesPage;
